module.exports = __webpack_public_path__ + "img/title_logo.b8d800dd.png";